// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import Modal from "@insite/mobius/Modal";
import TextArea, { TextAreaPresentationProps } from "@insite/mobius/TextArea";
import TextField from "@insite/mobius/TextField";
import { TextFieldPresentationProps } from "@store/MobiusOverrides/TextField/TextField";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { ModalPresentationProps } from "@store/MobiusOverrides/Modal/Modal";
import { getMediaQuery } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import React from "react";
import styled, { css } from "styled-components";

const emailRegex = new RegExp("!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i");
const mobileQuery = getMediaQuery({ option: "only", first: true, min: 0, max: 480, last: false });
const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 2rem;
    padding: 1.25rem;
    gap: 2rem;
    ${mobileQuery} {
        justify-content: center;
    }
`;

interface ProductFeedbackModalStyles {
    textArea: TextAreaPresentationProps;
    emailTextField: TextFieldPresentationProps;
    modal: ModalPresentationProps;
}
const ButtonSubmit = styled(Button)`
    ${props =>
        props.disabled &&
        css`
            background-color: #ffff; !important;
        `}

    font-weight: 700;
`;
const styles: ProductFeedbackModalStyles = {
    textArea: {
        css: css`
            && {
                ${mobileQuery} {
                    height: ${pxToRem(192)};
                }
            }
        `,
    },

    modal: {
        cssOverrides: {
            modalBody: css`
                ${mobileQuery} {
                    max-height: 75vh !important;
                    max-width: 90vw !important;
                }
            `,
        },
    },

    emailTextField: {
        cssOverrides: {
            formField: css`
                ${mobileQuery} {
                    margin-top: ${pxToRem(32)};
                }
            `,
        },

        css: css`
            && {
                margin-bottom: ${pxToRem(32)};
            }
        `,
    },
};
interface Props {
    isModalOpen: boolean;
    setIsModalOpen: (isModalOpen: boolean) => void;
    handleSubmit: (reportedBy: string, comment: string) => void;
}
const ProductFeedbackModal: React.FC<Props> = ({ isModalOpen, setIsModalOpen, handleSubmit }) => {
    const [textAreaValue, setTextAreaValue] = React.useState("");
    const [emailValue, setEmailValue] = React.useState("");
    const handleClick = () => {
        handleSubmit(emailValue, textAreaValue);

        setIsModalOpen(false);
    };
    return (
        <>
            <Modal
                headline={translate("Report Incorrect Information")}
                isOpen={isModalOpen}
                handleClose={() => setIsModalOpen(false)}
                {...styles.modal}
            >
                <TextField
                    {...styles.emailTextField}
                    error={emailValue && emailRegex.test(emailValue)}
                    label={translate("Email")}
                    onChange={e => setEmailValue(e.target.value)}
                    required
                    value={emailValue}
                    data-test-selector="pim_feedback_emailText"
                    placeholder={translate("Email Address")}
                />
                <TextArea
                    error={textAreaValue.length > 3000}
                    label={translate("Details")}
                    value={textAreaValue}
                    onChange={e => setTextAreaValue(e.target.value)}
                    required
                    {...styles.textArea}
                    placeholder={translate("Please provide details about incorrect information.")}
                />
                <ButtonContainer>
                    <ButtonSubmit
                        disabled={
                            !textAreaValue || textAreaValue.length > 3000 || !emailValue || emailRegex.test(emailValue)
                        }
                        onClick={handleClick}
                    >
                        {translate("Submit")}
                    </ButtonSubmit>

                    <Button onClick={() => setIsModalOpen(false)} variant="secondary">
                        {translate("Cancel")}
                    </Button>
                </ButtonContainer>
            </Modal>
        </>
    );
};

export default ProductFeedbackModal;
